import { render, staticRenderFns } from "./CompanyExcel.vue?vue&type=template&id=5534180c&scoped=true&"
import script from "./CompanyExcel.vue?vue&type=script&lang=js&"
export * from "./CompanyExcel.vue?vue&type=script&lang=js&"
import style0 from "./CompanyExcel.vue?vue&type=style&index=0&id=5534180c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534180c",
  null
  
)

export default component.exports